import $ from 'jquery'
import * as logger from '../../../abt-utils/logger'
import { applyDefault } from '../../../abt-utils/structure'
import { dataTrackInit } from '../data-track'

export function customCriteria (test) {
  var hasAdditionalPages = $('.results-pagination').length > 0

  if (!hasAdditionalPages) {
    logger.warn('ABT: abt543 removed - no additional pages')
  }

  return hasAdditionalPages ? test : null
}

export function a (test) {
  dataTrackInit()
  return test
}

export function b (test) {
  return System.import('./b')
    .then(applyDefault(test))
    .catch(logger.error)
}



/*****************
 ** WEBPACK FOOTER
 ** ./src/abt-tests/abt543/small/index.js
 ** module id = 58
 ** module chunks = 2
 **/